module.exports = __webpack_public_path__ + "static/img/2.d5ebee08.png";